import { createSelector, selector } from '@/store/utils';

const selectPurchaseFlowBooking = selector((state) => state.purchase.booking);
export const purchaseFlowBookingSelector = createSelector(
  selectPurchaseFlowBooking
);

const selectPurchaseFlowBookingId = selector(
  (state) => state.purchase.booking?.id
);
export const purchaseFlowBookingIdSelector = createSelector(
  selectPurchaseFlowBookingId
);

const selectOutboundData = selector((state) => state.purchase.outbound);
export const outboundDataSelector = createSelector(selectOutboundData);

const selectSelectedOutboundOfferMap = selector(
  (state) => state.purchase.outbound.selectedOfferMapByLegId
);
export const selectedOutboundOfferMapSelector = createSelector(
  selectSelectedOutboundOfferMap
);

const selectInboundData = selector((state) => state.purchase.inbound);
export const inboundDataSelector = createSelector(selectInboundData);

const selectSelectedInboundOfferMap = selector(
  (state) => state.purchase.inbound.selectedOfferMapByLegId
);
export const selectedInboundOfferMapSelector = createSelector(
  selectSelectedInboundOfferMap
);

const selectNonTripOffers = selector((state) => state.purchase.nonTripOffers);
export const nonTripOffersSelector = createSelector(selectNonTripOffers);

const selectPurchaseFlowTravelAccountsMap = selector(
  (state) => state.purchase.travelAccountsMap
);
export const purchaseFlowTravelAccountsMapSelector = createSelector(
  selectPurchaseFlowTravelAccountsMap
);
